import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=ccf965f2&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=js"
export * from "./NoteModal.vue?vue&type=script&lang=js"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=ccf965f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf965f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccf965f2')) {
      api.createRecord('ccf965f2', component.options)
    } else {
      api.reload('ccf965f2', component.options)
    }
    module.hot.accept("./NoteModal.vue?vue&type=template&id=ccf965f2&scoped=true", function () {
      api.rerender('ccf965f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoteModal/NoteModal.vue"
export default component.exports